import script from "./num_pad_display.vue?vue&type=script&setup=true&lang=js"
export * from "./num_pad_display.vue?vue&type=script&setup=true&lang=js"

import "./num_pad_display.vue?vue&type=style&index=0&id=c6d9710a&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6d9710a"]])

export default __exports__